import React, { useState, useEffect } from 'react'
import './ReviewMenu.scss'

const ReviewMenu = props => {
    const copyToClipboard = (text) => {
        let fake = document.createElement("textarea");
        fake.value = text;
        document.body.appendChild(fake);
        fake.select();
        document.execCommand("copy");
        document.body.removeChild(fake);

        const notice = document.querySelector('.copied-notification');
        const old = notice.innerHTML;
        notice.innerHTML = "Copied!"

        setTimeout(()=>{
            notice.innerHTML = old;
        }, 2000)

    }


    return (
        <div className="ReviewMenu">
            <div className="navigation">
                {(props.contentData && props.contentData.modules) &&
                    props.contentData.modules.map((module, moduleIndex) => {
                      return <Module module={module} moduleIndex={moduleIndex} key={`module-${moduleIndex}`} moduleProgress={props.progress ? props.progress.modules[moduleIndex] : undefined} {...props}/>
                    })
                }
            </div>
            <div className={`cheats`}>
                <div className={`item`} onClick={props.resetSegment}>Reset Segment</div>
                <div className={`item`} onClick={()=>props.markSegmentComplete()}>Mark Current Segment Complete</div>
                <div className={`item copied-notification`} onClick={()=>copyToClipboard(props.generateLocationLink())}>Copy Deeplink</div>
                {/* <div className={`item`}>Cheat a</div>
                <div className={`item`}>Cheat b</div>
                <div className={`item`}>Cheat c</div>
                <div className={`item`}>Cheat d</div> */}
            </div>
        </div>
    )
}

const Module = props => {
    const isCurrent = (props.currentLocation.module === props.moduleIndex)
    const [open, setOpen] = useState(isCurrent);
    useEffect(()=>{
        setOpen(isCurrent)
    }, [isCurrent, setOpen])
    return <div className={`layer module  ${open ? 'open' : 'closed'}`}>
        <div className={`label`} onClick={()=> setOpen(!open)}>{`Module ${props.moduleIndex}`} <div className={'name'}>{props.module.name}</div></div>
        {
            (props.module && props.module.lessons) &&
            props.module.lessons.map((lesson, lessonIndex) => {
                return <Lesson lesson={lesson} lessonIndex={lessonIndex}  isSolo={props.module.lessons.length === 1} {...props}
                key={`module-${props.moduleIndex} lesson-${lessonIndex}`}
                lessonProgress={props.moduleProgress ? props.moduleProgress.lessons[lessonIndex] : undefined}/>
            })
        }
    </div>
}
const Lesson = props => {
    const getCompletePercent = () => {
        let complete = 0;
        let total = 0;
        props.lessonProgress.chapters.forEach((chapter)=>{
            chapter.segments.forEach(segment => {
                total++;
                if(segment.status === 'complete') complete ++;
            })
        })
        return Math.floor((complete/total)*100)
    }

    const completePercent = props.lessonProgress ? getCompletePercent() : 0;

    const isCurrent = (props.currentLocation.module === props.moduleIndex) &&
    (props.currentLocation.lesson === props.lessonIndex)
    const [open, setOpen] = useState(isCurrent || props.isSolo);

    useEffect(()=>{
        if(!props.isSolo) setOpen(isCurrent)
    }, [props.isSolo, isCurrent, setOpen])

    return <div className={`layer lesson ${open ? 'open' : 'closed'}`}>
        <div className={`label`} onClick={()=> setOpen(!open)}>{`Lesson ${props.lessonIndex}`}
        <div className={`name`}>{`${props.lesson.name}`}</div>
        <div className={`complete`}>{completePercent}%</div>

        </div>
        {
            (props.lesson && props.lesson.chapters) &&
            props.lesson.chapters.map((chapter, chapterIndex) => {
                return <Chapter chapter={chapter} chapterIndex={chapterIndex} isSolo={props.lesson.chapters.length === 1} {...props}
                key={`module-${props.moduleIndex} lesson-${props.lessonIndex} chapter-${chapterIndex}`}
                chapterProgress={props.lessonProgress ? props.lessonProgress.chapters[chapterIndex] : undefined}
                />
            })
        }
    </div>
}
const Chapter = props => {
    const getCompletePercent = () => {
        let complete = 0;
        let total = 0;
        props.chapterProgress.segments.forEach((segment)=>{
            total++;
            if(segment.status === 'complete') complete ++;
        })
        return Math.floor((complete/total)*100)
    }

    const completePercent = props.chapterProgress ? getCompletePercent() : 0;
    const isCurrent = (props.currentLocation.module === props.moduleIndex) &&
    (props.currentLocation.lesson === props.lessonIndex) &&
    (props.currentLocation.chapter === props.chapterIndex)
    const [open, setOpen] = useState(props.isSolo || isCurrent);
    useEffect(()=>{
        if(!props.isSolo) setOpen(isCurrent)
    }, [props.isSolo, isCurrent, setOpen])

    return <div className={`layer chapter ${open ? 'open' : 'closed'}`}>
        <div className={`label`} onClick={()=> setOpen(!open)}>{`Chapter ${props.chapterIndex}`}
        <div className={`name`}>{`${props.chapter.name}`}</div></div>
        <div className={`complete`}>{completePercent}%</div>
        {
            (props.chapter && props.chapter.segments) &&
            props.chapter.segments.map((segment, segmentIndex) => {
                return <Segment segment={segment} segmentIndex={segmentIndex} {...props}
                key={`module-${props.moduleIndex} lesson-${props.lessonIndex} chapter-${props.chapterIndex} segment-${segmentIndex}`}
                segmentProgress={props.chapterProgress ? props.chapterProgress.segments[segmentIndex] : undefined}
                />
            })
        }
    </div>
}
const Segment = props => {
    if (!props.segment) return null
    const isCurrent = (props.currentLocation.module === props.moduleIndex) &&
        (props.currentLocation.lesson === props.lessonIndex) &&
        (props.currentLocation.chapter === props.chapterIndex) &&
        (props.currentLocation.segment === props.segmentIndex)

    return <div className={`layer segment ${isCurrent ? 'current' : ''}`}>
        <div className={`label`} onClick={()=>{
            props.setCurrentLocation({
                module:props.moduleIndex,
                lesson:props.lessonIndex,
                chapter:props.chapterIndex,
                segment:props.segmentIndex
            })
        }}>{`Segment ${props.segmentIndex}`}
        <div className={`name`}>{`${props.segment.type}`}</div>
            {props.segmentProgress !== undefined && <div className={`complete ${props.segmentProgress.status === 'complete' ? 'check' : ''}`}>{props.segmentProgress.complete ? '' : ''}</div>}
        </div>
    </div>
}


export default ReviewMenu
